import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['content', 'triggerText', 'triggerIcon'];

  toggle() {
    $(this.contentTarget).transition("toggle");

    if(this.contentTarget.classList.contains('hidden')) {
      this.triggerIconTarget.classList.remove("up")
      this.triggerIconTarget.classList.add("down")
      this.triggerTextTarget.innerText = "Rozwiń"
    } else {
      this.triggerIconTarget.classList.remove("down")
      this.triggerIconTarget.classList.add("up")
      this.triggerTextTarget.innerText = "Zwiń"
    }
  }
}
